// removed by extract-text-webpack-plugin
module.exports = {"warp":"pages-MyAccount-share-VerifyStatus-warp","hint":"pages-MyAccount-share-VerifyStatus-hint","hint-needL1":"pages-MyAccount-share-VerifyStatus-hint-needL1","hint-warning":"pages-MyAccount-share-VerifyStatus-hint-warning","hint-pending":"pages-MyAccount-share-VerifyStatus-hint-pending","btn":"pages-MyAccount-share-VerifyStatus-btn","fakeBtn":"pages-MyAccount-share-VerifyStatus-fakeBtn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/share/VerifyStatus/index.css
// module id = 1811
// module chunks = 0